import { render, staticRenderFns } from "./OrderQuotation.vue?vue&type=template&id=c6975bd4&scoped=true"
import script from "./OrderQuotation.vue?vue&type=script&lang=js"
export * from "./OrderQuotation.vue?vue&type=script&lang=js"
import style0 from "./OrderQuotation.vue?vue&type=style&index=0&id=c6975bd4&prod&lang=scss&scoped=true"
import style1 from "./OrderQuotation.vue?vue&type=style&index=1&id=c6975bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6975bd4",
  null
  
)

export default component.exports